











import { Component, Prop, Vue } from "vue-property-decorator";

import { ILanguage } from "../domain";
import MenuItem from "./MenuItem.vue";

@Component({ components: { MenuItem } })
export default class extends Vue {
  @Prop(Array)
  private languages: ILanguage[];

  private get recentlyViewedLanguages(): ILanguage[] {
    return this.languages.filter(
      ({ id }: ILanguage): boolean => {
        const language = this.$store.state.languages[id];
        return language && language.viewPoints > 0;
      }
    );
  }
}
